import { FILTER, SEARCHQUERY } from "./actionTypes";
import { initialState } from "./initialState";

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCHQUERY:
      return {
        ...state,
        searchQuery: action.payload,
      };
    case FILTER:
      return {
        ...state,
        filter: action.payload,
      };
    default:
      return state;
  }
};
